import React from 'react';
import type { EntityCellProps } from '../../../../model/index.tsx';
import PublicVsPrivateSwitchCell from '../common/public-vs-private-switch-cell/index.tsx';
import PublicCell from './public/index.tsx';

const FavoriteCell = (props: EntityCellProps): React.JSX.Element => (
	<PublicVsPrivateSwitchCell {...props}>
		{/* @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'. */}
		{({ isPrivate }) => (isPrivate ? null : <PublicCell {...props} />)}
	</PublicVsPrivateSwitchCell>
);

export default FavoriteCell;
